import React from 'react';

import styled from 'styled-components';
import { FlexContainer, StyledPaper } from 'styles/common';

import NotAvailable from 'assets/images/NotAvailable.png';

import { Typography2, Typography6 } from 'uiToolkit/Typography';

export const NoDataComponentTeamHub = ({ isGoalView, padding = '5rem' }) => {
  const noDataText = isGoalView ? 'No goals to display' : 'No Initiatives to display';
  return (
    <StyledPaper elevation={0}>
      <StyledFlexContainer padding={padding}>
        <StyledImage src={NotAvailable} alt={noDataText} />
        <Typography6>{noDataText}</Typography6>
        <Typography2 style={{ whiteSpace: 'break-spaces', textAlign: 'center' }} />
      </StyledFlexContainer>
    </StyledPaper>
  );
};
const StyledFlexContainer = styled(FlexContainer)`
  padding: ${(props) => props.padding ?? '2.5rem'};
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const StyledImage = styled.img`
  height: 15rem;
`;
